import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IAddRoleSchema, IRole, IRoleState } from './types';

const initialState: IRoleState = {
  addRole: {},
  roles: {},
  module: {},
  updateRoleStatus: {},
};

const slice = createSlice({
  name: 'addRole',
  initialState,
  reducers: {
    getRole(state) {
      state.roles.status = RequestStatus.RUNNING;
    },
    getRoleSuccess(state, action: PayloadAction<IRoleState['roles']['data']>) {
      state.roles.status = RequestStatus.SUCCESS;
      state.roles.data = action.payload;
    },
    getRoleFailed(state, action: PayloadAction<IRequestFailed>) {
      state.roles.status = RequestStatus.ERROR;
      state.roles.error = action.payload;
    },
    //
    getModule(state) {
      state.module.status = RequestStatus.RUNNING;
    },
    getModuleSuccess(state, action: PayloadAction<IRoleState['module']['data']>) {
      state.module.status = RequestStatus.SUCCESS;
      state.module.data = action.payload;
    },
    getModuleFailed(state, action: PayloadAction<IRequestFailed>) {
      state.module.status = RequestStatus.ERROR;
      state.module.error = action.payload;
    },
    //
    addRole(state, action: PayloadAction<IAddRoleSchema>) {
      state.addRole.status = RequestStatus.RUNNING;
    },
    addRoleSuccess(state, action: PayloadAction<IRoleState['addRole']['data']>) {
      state.addRole.status = RequestStatus.SUCCESS;
      state.addRole.data = action.payload;
    },
    addRoleFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addRole.status = RequestStatus.ERROR;
      state.addRole.error = action.payload;
    },
    //
    updateRoleStatus(state, action: PayloadAction<any>) {
      state.updateRoleStatus.status = RequestStatus.RUNNING;
    },
    updateRoleStatusSuccess(state, action: PayloadAction<IRole>) {
      state.updateRoleStatus.status = RequestStatus.SUCCESS;
      state.updateRoleStatus.data = action.payload;
    },
    updateRoleStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateRoleStatus.status = RequestStatus.ERROR;
      state.updateRoleStatus.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  getRole,
  getRoleSuccess,
  getRoleFailed,
  getModule,
  getModuleFailed,
  getModuleSuccess,
  addRole,
  addRoleFailed,
  addRoleSuccess,
  updateRoleStatus,
  updateRoleStatusFailed,
  updateRoleStatusSuccess,
} = slice.actions;
